<!-- <mat-card class="mat-elevation-z8"> -->
  <!-- <h1 style="text-align: center; text-transform: capitalize;">{{global.get_master_page_title}}</h1> -->
<!-- </mat-card> -->
<mat-card class="navbar navbar-dark bg-dark mat-elevation-z8" style="width: 50%; text-align: center; text-transform: capitalize; color: white;">
  <div style="font-size: 20px;">{{global.get_master_page_title}}</div>
</mat-card>
